import { Flex } from 'mds-web-ui'
import React from 'react'
import Helmet from 'react-helmet'

import SEO from '../SEO'
import { TopNav } from '../TopNav'
import { Footer } from '../shared/Footer'

export const FlowGalleryWrapper = ({
  title,
  description,
  children,
  image,
  slug,
  appIcons,
  ...props
}) => {
  return (
    <>
      <Helmet title={title} />
      <SEO
        title={title}
        description={
          description
            ? description
            : 'Artwork we love from Flow shared with the world.'
        }
        image={image}
        path={slug}
        noindex
      />
      <TopNav position="sticky" imageData={appIcons} />

      <Flex as="main" justifyContent="center" {...props}>
        {children}
      </Flex>

      <Footer bg="#fff" />
    </>
  )
}
